export default {
    showVariationsModal: {
        copy: 'Copie',
        contentVariation: 'Variation de contenu',
        chosenContent: 'Contenu choisi',
        chosenContentPlaceholder: 'Veuillez entrer',
        continue: 'Continuer',
        generateNewContent: 'Générer un nouveau contenu',
        type: 'Type :',
        contentTitle: 'Titre :',
        descriptionLabel: 'Description :',
        keywordsLabel: 'Mots clés :',
        writingTone: "Ton d'écriture :",
        context: 'Contexte :',
        cancel: 'Annuler',
        emailBuilderTooltip: 'Custom values for sender and recipient is added in the content.',
    },
};
